
'use client' 

import CardEbook from "@/app/component/Card/Card";
import { imageLoader } from "@/lib/functionloader";
import dynamic from "next/dynamic"
import Image from "next/image";
import { useEffect, useState } from "react";
 
import Hashids from "hashids";
import { useGlobalContext } from "@/app/component/context/provider";
import { useRouter } from "next/navigation";
import { getLocalStorage, setLocalStorage } from "@/lib/localStorage";

import CryptoJS from "crypto-js";
import { message } from "antd";

import {AxiosPostData} from '@/app/component/context/axiosfunction'

const EbookSetPage = ({Edata}) => {

    const router = useRouter()
    const [messageApi, contextHolder] = message.useMessage();
    const { privateKey , DataUser , DataShalve , refreshCart,API,Token,headers } = useGlobalContext()
    const  [ebookData , setEbookData] = useState(null);
    const [ bookCanBuy, setBookCanBuy ] = useState([]);
    const [summaryCoin, setSummaryCoin] = useState(0);


    useEffect(() => {
        if (Edata?.BookSeries?.length > 0) {
            const firstBook = Edata.BookSeries[0]; 
            const shalveList = Array.isArray(DataShalve) ? DataShalve.map(Number) : [];
            const bookCanBuy = Edata.BookSeries.filter(book => !shalveList.includes(Number(book.id))); 
            
            const summaryCoin = bookCanBuy.reduce((total, book) => {
                let coinPrice = Number(book.coin_price);
                if (coinPrice > 0) {
                    if (book.dis_per) {
                        // หากมีการลดราคา
                    } else if (book['Bcam.campaign_id']) {
                        // หากมีแคมเปญ
                        if (book['Bcam.campaign_type'] === "Free") {
                            coinPrice = 0; // อ่านฟรี
                        } else {
                            coinPrice = Math.floor(Number(coinPrice) * (100 - book['Bcam.campaign_discount']) / 100);
                        }
                    }
                } 

                return total + coinPrice;
            }, 0); 
            
            setBookCanBuy(bookCanBuy);
            setSummaryCoin(summaryCoin);
            
            const data = {
                banner_img: firstBook['Edata.banner_img'], 
                name:firstBook['Edata.name'], 
                book_image: firstBook['Edata.banner_img'] || firstBook.book_image,
                partner:firstBook['Edata.partner.name'],
                partner_id:firstBook['Edata.partner.id'],
                author:firstBook['Edata.author.name'],
                coin_price:Number(firstBook.coin_price),
                review:Number(firstBook.score),
                book_series_id:firstBook.id,
                dis_per:Number(firstBook.dis_per),
                campaign_type:firstBook['Bcam.campaign_type'],
                campaign_id:firstBook['Bcam.campaign_id'],
                campaign_discount:firstBook['Bcam.campaign_discount'],
                cam_start:firstBook['Bcam.start_date'],
                cam_end:firstBook['Bcam.end_date'],
                title:firstBook['title'],
                author_id:firstBook['Edata.author.id'],
            }
            setEbookData(data);
        }
    }, [Edata]);

    
    const DirectMarket = (key,type)=>{
            
        const hashids = new Hashids(privateKey,6)
        const encodedID = hashids.encode(key)
        const url = `${encodedID}_${type}`
        router.push(`/marketplace/${url}`)
    
    }

    const AddToCartFunction = async(dataset) => { 
        // console.log(dataset);
        
        const existingEncrypted = getLocalStorage('Cart')?.value;
        
        let cart = [];
            
        if (existingEncrypted) {
            try {
                const bytes = CryptoJS.AES.decrypt(existingEncrypted, privateKey);
                const decrypted = bytes.toString(CryptoJS.enc.Utf8);
                cart = JSON.parse(decrypted);
            } catch {
                cart = [];
            }
        }
        
        for(const data of dataset){
            if(cart.some(cartdata=>cartdata.book_series_id == data.id)){
                continue;
            } 
            
            cart.unshift({
                book_series_id: data.id,
                name: data['Edata.name'],
                series_number: data.series_number,
                partner_id: data['Edata.partner.id'],
                partner_name:data['Edata.partner.name'],
                dis_per: data.dis_per,
                coin_price:  data.campaign_id ? 
                    data.coin_price-Math.floor(data.coin_price * data['Bcam.campaign_discount']/100)
                    :  data.coin_price,
                book_image: data.book_image,
                author:data['Edata.author.name']
            });
        }

        if(Token){
            const book_series_id = dataset.map(data => data.id).join(',')
            await AxiosPostData(API,'/api/add_cart',{book_series_id:book_series_id},headers)
        }
    
        const encrypted = CryptoJS.AES.encrypt(JSON.stringify(cart), privateKey).toString();
        setLocalStorage('Cart', { value: encrypted } );
        refreshCart()
    }

    const AddToCart = (dataset) => {
            if (!dataset || dataset.length === 0) {
                messageApi.open({ type: 'error', content: 'ไม่มีหนังสือให้เพิ่มเข้าตะกร้า' });
                return;
            }
            AddToCartFunction(dataset);
            messageApi.open({ 
                type:'success',
                content:'เพิ่มหนังสือเข้าตะกร้าแล้ว'
            })
        }
    
        const ToCart = (dataset) => {
            if (!dataset || dataset.length === 0) {
                messageApi.open({ type: 'error', content: 'ไม่มีหนังสือให้เพิ่มเข้าตะกร้า' });
                return;
            }
            AddToCartFunction(dataset);
            window.location.href="/cart"
        }

    
    return( ebookData &&
        <div className="bg-web xl:max-w-[1200px] gap-[30px] md:gap-[40px] xl:mx-auto md:px-[24px] px-3 xl:!py-10 ">
            {contextHolder}
            <div className="md:grid md:grid-cols-12 gap-10 mb-5">
                <div className="md:col-span-5 relative w-full aspect-[1200/720] rounded-[8px] shadow-md overflow-hidden">
                    <Image
                        src={ebookData?.book_image}
                        loader={imageLoader}
                        alt={ebookData?.name}
                        fill
                        className="object-cover"
                        sizes="100%"
                        loading="lazy"
                    />
                </div>
                <div className="md:col-span-7 flex flex-col justify-between ">
                    <div>
                        <p className="text-[24px] font-bold text-wrap">{ebookData?.name}</p>

                        <div className="flex gap-[16px] xl:gap-[25px] mt-[8px]">
                            <div className="font-bold">โดย : <button onClick={()=>DirectMarket(ebookData?.partner_id,'p')} className="font-normal text-special">{ebookData?.partner}</button></div>
                            <div className="font-bold">ผู้เขียน : <button onClick={()=>DirectMarket(ebookData?.author_id,'a')} className="font-normal text-special">{ebookData?.author}</button></div>
                        </div>
                    </div>
                        
                    
                    <div className="">
                        <div className="text-[38px] font-bold text-special py-[20px]">
                            ฿{summaryCoin.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                        </div>
                        
                        <button onClick={()=>ToCart(bookCanBuy)} className="btn-primary w-[120px] md:w-[149px] h-[48px]">
                            ซื้อเลย
                        </button>

                        <span className="mx-5">หรือ</span>

                        <button onClick={()=>AddToCart(bookCanBuy)} className="page-surface cursor-pointer rounded-[8px] w-[115px] md:w-[140px] h-[48px]">เพิ่มเข้าตะกร้า</button>
                    </div>
                </div>
            </div>

            <hr className="my-10 border-gray-300" />
            
            <div className="grid grid-cols-3 md:grid-cols-5 xl:grid-cols-6 gap-[16px] md:gap-[24px] xl:gap-[32px]">
                {Edata?.BookSeries?.length > 0 && Edata.BookSeries.map((book, index) => (
                    <CardEbook key={index} Ebookdata={book} type="SeriesToBook" />
                ))}
            </div>
            
        </div>
    )
}

export default EbookSetPage